import React from 'react';
import { render, screen } from '@testing-library/react';
import '@testing-library/jest-dom';
import Confirm from './confirm';

describe('Confirm', () => {
  test('renders Confirm component', () => {
    const tickets = [{ id: 1, name: "100枚チケット", price: 1000, issue_number: 100, valid_period_day: 90 }]
    render(<Confirm m_tickets={tickets} total_price={1000} />);

    // screen.debug();
    expect(screen.getByText('100枚チケット')).toBeInTheDocument();
    expect(screen.getByText('以下の内容で購入を確定します。')).toBeInTheDocument();
  });
});
